import React from "react";
import styles from "./index.module.scss";
export function SupportOfficeHours() {
    return React.createElement("span", { className: styles.blue }, "9am to 5.30pm, Monday to Friday.");
}
